import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Input, Button, Segment, Header, Icon } from 'semantic-ui-react'
import { getFormValues, reduxForm } from 'redux-form'
import { compose, lifecycle } from 'recompose'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import { Typography, Card, CardMedia, CardContent, Collapse, Fade, CircularProgress } from '@material-ui/core'
import SubCategoryCell from './SubCategoryCell'
import { ProcurementBody } from '../../../styled'
import { PurchaseGroupMenuContainer } from './styled'
import { selectSubCategory, getRecommendItems } from 'ducks/purchaseRequisition'
import { getMappingPurchasingGroups, getMappingPrItemFields } from 'ducks/mappingData'
// import placeholderImg from 'assets/images/placeholder.png'
import prImgCate from 'assets/images/prCategory'
import r from 'reactotron-react-js'

const SelectCategory = (props) => {
  const { change, valueForm, menus, menuLoading, handleSubmit, selectSubCategory } = props

  const [searchKey, setSearchKey] = useState('')

  const searchMenu = searchKey ? menus.filter(m => {
    
    let menuSearch = m.nameEn.toLowerCase().indexOf(searchKey.toLowerCase())
    let subMenuSearch = m.subCategories.filter(s => 
      (s.nameEn.toLowerCase().indexOf(searchKey.toLowerCase()) !== -1) ||
      (s.descriptionEn.toLowerCase().indexOf(searchKey.toLowerCase()) !== -1)
    )
    return (menuSearch !== -1) || (subMenuSearch.length)
  }) : menus

  return (
    <Collapse in timeout={0}>
      <Fade in timeout={1000} >
        <ProcurementBody>
          <Input 
            fluid 
            icon='search'
            value={searchKey}
            iconPosition='left' 
            placeholder='Search...' 
            onChange={(e, data) => setSearchKey(data.value)}
          />
          <PurchaseGroupMenuContainer>
            { menuLoading ? <CircularProgress color='primary' /> : null}
            <form 
              onSubmit={handleSubmit} 
              style={{ display: 'flex', flex: 1, width: '100%', justifyContent: 'center' }}>
              {
                searchMenu.length !== 0 ?
                  <ResponsiveMasonry 
                    style={{ width: '100%' }} 
                    columnsCountBreakPoints={{ 210: 1, 420: 2, 630: 3, 840: 4, 1060: 5 }} >
                    <Masonry>
                      {
                        searchMenu.map((m,i) => 
                          <Card key={m.nameEn} className='cardMenu'>
                            <CardMedia 
                              image={m.image || prImgCate[m.code]}
                              title={m.nameEn}
                              style={{ height: '100px' }}
                              onClick={() => {
                                if (m.subCategories.length === 1) {
                                  change('menuCategory', m.code)
                                  change('menuSubCategory', m.subCategories[0].code)
                                  selectSubCategory(m.subCategories[0])
                                } else {
                                  if (valueForm && valueForm.menuCategory === m.code) {
                                    change('menuCategory', '')
                                  } else {
                                    change('menuCategory', m.code)
                                  }
                                }
                              }}
                            />
                            <CardContent onClick={() => {
                              if (m.subCategories.length === 1) {
                                change('menuCategory', m.code)
                                change('menuSubCategory', m.subCategories[0].code)
                                selectSubCategory(m.subCategories[0])
                              } else {
                                if (valueForm && valueForm.menuCategory === m.code) {
                                  change('menuCategory', '')
                                } else {
                                  change('menuCategory', m.code)
                                }
                                //setFormStep(1)
                              }
                            }}>
                              <Typography>{m.nameEn}</Typography>
                            </CardContent>
                            <Collapse in={valueForm && valueForm.menuCategory === m.code}>
                              <CardContent>
                                {m.subCategories.map(s => 
                                  <Button key={s.nameEn} type='submit' style={{ padding: '0px', borderRadius: '0px', width: '100%', background: 'transparent' }}>
                                    <SubCategoryCell 
                                      title={s.nameEn}
                                      description={s.descriptionEn}
                                      onClick={() => {
                                        change('menuSubCategory', s.code)
                                        selectSubCategory(s)
                                      }} />
                                  </Button>
                                )}
                              </CardContent>
                            </Collapse>
                          </Card>
                        )
                      }
                    </Masonry>
                  </ResponsiveMasonry> :
                  searchKey !== '' ?
                  <Segment placeholder style={{ width: '100%' }}>
                    <Header icon>
                      <Icon name='search' />
                      {'Result not found'}
                      <br />
                      {''}
                    </Header>
                  </Segment> : null
              }
            </form>
          </PurchaseGroupMenuContainer>
        </ProcurementBody>
      </Fade>
    </Collapse>
  )
}

const mapStateToProps = (state) => {
  const valueForm = getFormValues('formCreatePR')(state)
  return({
    menuLoading: state.pr.menuLoading,
    menus: state.pr.menus,
    mappingPurchasingGroups: state.mappingData.purchasingGroups.data,
    prItemFields: state.mappingData.prItemFields.data,
    recommendItems: state.pr.recommendItems.data,
    initialValues: {
      ...valueForm,
    },
    valueForm
  })
}

const mapDispatchToProps = {
  selectSubCategory,
  getMappingPurchasingGroups,
  getMappingPrItemFields,
  getRecommendItems,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formCreatePR',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  lifecycle({
    componentDidMount() {
      const { mappingPurchasingGroups, getMappingPurchasingGroups,
        prItemFields, getMappingPrItemFields,
        recommendItems, getRecommendItems } = this.props

      if (!mappingPurchasingGroups.length) {
        getMappingPurchasingGroups()
      }

      if (prItemFields.itemName.K === undefined) {
        getMappingPrItemFields()
      }

      if (!recommendItems.length) {
        getRecommendItems()
      }
    },
  })
)

export default enhance(SelectCategory)
